<template>
  <div class="content">
    <base-block class="mb-0" rounded title="Add Topic">
      <div class="row">
        <div class="col-md-6 form-group">
          Select Topic
          <b-form-select v-model="topic">
            <option
              v-for="(topic, index) in topics"
              :key="index"
              :value="topic.label"
            >
              {{ topic.label }}
            </option>
          </b-form-select>
        </div>

        <div class="col-md-6 form-group" v-if="topic == 'Add Parent Topic'">
          <p id="parentTopicIdLabel" class="mb-0">Parent Topic</p>
          <input
            id="parentTopicId"
            v-model="parentTopicName"
            @focus="parentTopicNameEmpty = false"
            class="form-control"
            type="text"
          />
        </div>

        <div
          class="text-center col-md-12 form-group"
          v-if="parentTopicName != '' && topic == 'Add Parent Topic'"
        >
          <b-button class="text-center mb-2" variant="success" @click="insert()"
            >Insert</b-button
          >
        </div>

        <div
          class="col-md-6 form-group"
          v-if="topic != 'Add Parent Topic' && topic != ''"
        >
          Select Subtopic
          <b-form-select id="subtopicID" v-model="subtopic">
            <option v-for="(subTopic, index) in subTopics" :key="index">
              {{ subTopics[index].label }}
            </option>
          </b-form-select>
        </div>

        <div
          class="col-md-6 form-group"
          v-if="subtopic == 'Add Parent Subtopic'"
        >
          <p id="parentSubtopicLabel" class="mb-0">Parent Subtopic</p>
          <input
            id="subtopicNameID"
            class="form-control"
            type="text"
            v-model="parentSubtopic"
          />
        </div>

        <div
          class="col-md-6 form-group"
          v-if="subtopic == 'Add Parent Subtopic'"
        >
          <p id="descriptionLabel" class="mb-0">Description</p>
          <input
            id="subtopicDescription"
            class="form-control"
            type="text"
            v-model="parentSubtopicDescription"
          />
        </div>

        <div
          class="col-md-6 form-group"
          v-if="subtopic == 'Add Parent Subtopic'"
        >
          <p id="topicTypeLabel" class="mb-0">Topic Type</p>
          <b-form-select id="subtopicTopicType">
            <option value="Paid">Paid</option>
            <option value="Free">Free</option>
          </b-form-select>
        </div>

        <div
          id="subtopicImage"
          class="col-md-6 form-group"
          v-if="subtopic == 'Add Parent Subtopic'"
        >
          <p id="imageLabel" class="mb-0">Image</p>
          <b-form-file></b-form-file>
        </div>

        <div
          class="text-center col-md-12 form-group"
          id="insertSubtopicbutton"
          v-if="parentSubtopic != '' && subtopic == 'Add Parent Subtopic'"
        >
          <b-button
            class="text-center mb-2"
            variant="success"
            @click="insertSubtopic()"
            >Insert</b-button
          >
        </div>
      </div>

      <div class="row">
        <div
          class="col-md-6 form-group"
          v-if="subtopic != 'Add Parent Subtopic' && subtopic != ''"
        >
          Name
          <input class="form-control" type="text" />
        </div>

        <div
          class="col-md-6 form-group"
          v-if="subtopic != 'Add Parent Subtopic' && subtopic != ''"
        >
          Description
          <input style="display: block" class="form-control" type="text" />
        </div>

        <div
          class="col-md-6 form-group"
          v-if="subtopic != 'Add Parent Subtopic' && subtopic != ''"
        >
          Topic Type
          <b-form-select>
            <option value="Paid">Paid</option>
            <option value="Free">Free</option>
          </b-form-select>
        </div>

        <div
          class="col-md-6 form-group"
          v-if="subtopic != 'Add Parent Subtopic' && subtopic != ''"
        >
          Image
          <b-form-file></b-form-file>
        </div>
      </div>

      <div
        class="text-center"
        v-if="subtopic != 'Add Parent Subtopic' && subtopic != ''"
      >
        <b-button class="text-center pt-2 pb-2 pr-4 pl-4 mb-4" variant="success"
          >Save</b-button
        >
      </div>
    </base-block>
    <br />
  </div>
</template>

<script>
import axios from "axios";
export default {
  mounted() {
    this.loadTopicOptions();
  },
  methods: {
    async loadTopicOptions() {
      await axios
        .get(`${this.$store.getters.baseUrl}/topics`, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.token}`,
          },
        })
        .then((response) => {
          console.log(response);
          for (var i = 0; i < response.data.topics.length; i++) {
            this.topics.push({
              label: response.data.topics[i].name,
              value: response.data.topics[i].name,
            });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async insert() {
      const formdata = new FormData();
      formdata.append("name", this.parentTopicName);
      await axios
        .post(`${this.$store.getters.baseUrl}/topic/store`, formdata, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.token}`,
          },
        })
        .then((response) => {
          this.topics.push({
            label: this.parentTopicName,
            value: this.parentTopicName
          });
          console.log(response);
        })
        .catch((error) => {
          console.log(error);
        });

      this.parentTopicName = "";
      document.getElementById("parentTopicId").style.visibility = "hidden";
      document.getElementById("parentTopicIdLabel").style.visibility = "hidden";
    },
    insertSubtopic() {
      this.parentSubtopic = "";
      document.getElementById("parentSubtopicLabel").style.display = "none";
      document.getElementById("subtopicNameID").style.display = "none";
      document.getElementById("descriptionLabel").style.display = "none";
      document.getElementById("subtopicDescription").style.display = "none";
      document.getElementById("topicTypeLabel").style.display = "none";
      document.getElementById("subtopicTopicType").style.display = "none";
      document.getElementById("imageLabel").style.display = "none";
      document.getElementById("subtopicImage").style.display = "none";
      document.getElementById("insertSubtopicbutton").style.display = "none";
    },
  },
  data() {
    return {
      topics: [
        {
          label: "Add Parent Topic",
          value: "Add Parent Topic",
        },
      ],
      topic: "",
      parentTopicName: "",
      subtopic: "",
      parentSubtopic: "",
      subTopics: [
        { label: "Add Parent Subtopic", value: "Add Parent Subtopic" },
      ],
      parentSubtopicDescription: "",
    };
  },
};
</script>